<p-toast></p-toast>
<div class="col-12">
  <div class="card" reflow="true">
    <h5 class=" ">{{ "UNHIDE_APPLICATION" | translate }}</h5>
    <div class="card applicationDetails">
      <form [formGroup]="applicationForm" (ngSubmit)="submitApplication()">
        <div class="p-fluid p-formgrid grid justify-content-around">
          <div class="field col-12 md:col-4">
            <label>{{ "APPLICATION_NUMBER" | translate }}</label>
            <input
              pInputText
              id="applicationNo"
              type="text"
              formControlName="applicationNo"
              [ngClass]="{
                'ng-invalid ng-dirty': isSubmitted && f.applicationNo.errors
              }"
              placeholder="{{ 'APPLICATION_NO' | translate }}"
            />
            <a *ngIf="!f.applicationNo.errors" class="my-2" style="cursor: pointer;" (click)="clearAppNo()">{{ "CLEAR_APPLICATION_NO" | translate }}</a>
            <div
              *ngIf="isSubmitted && f.applicationNo.errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.applicationNo.errors.required">
                {{ "APPLICATION_NO_IS_REQUIRED" | translate }}
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label htmlFor="block">{{'Upload Doc' | translate}}</label>
            <div class="flex">
              <p-fileUpload accept=".jpeg,.pdf,.jpg" #supportingFileUpload [customUpload]="true"
                (uploadHandler)="onUpload($event, 'docPath', supportingFileUpload)" name="myfile[]" mode="basic"
                [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
              </p-fileUpload>
              <p-image *ngIf="f.docPath.value"
                [src]="f.docPath.value" [preview]="true" alt="Image" width="60"
                class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
            </div>
            <div *ngIf="isSubmitted && f.docPath.errors" class="invalid-feedback">
              <div *ngIf="f.docPath.errors.required">{{'Supporting Doc is required' |
                translate}}</div>
            </div>
          </div>
          <div class="field col-12 md:col-2">
            <label>{{ "" | translate }}</label>
            <button pButton pRipple type="submit" label="{{ 'UNHIDE' | translate }}" class="p-button-success m-2"></button>
          </div>
        </div>
      </form>
      <!-- <button
        pButton
        pRipple
        type="button"
        label="{{ 'UNHIDE' | translate }}"
        class="p-button-success m-2"
        (click)="submitApplication()"
      ></button> -->
    </div>
  </div>
</div>
